import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const Heart = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-heart',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.heart.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps
  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="M16.64,3.11c-2.08,0.05-3.92,1.37-4.66,3.35c-0.76-1.99-2.62-3.32-4.72-3.35C4.04,3.11,2,5.68,2,9.26c0,7.52,8.99,11.63,9.98,11.63c0.99,0,10.02-4.1,10.02-11.63C22,5.68,19.89,3.11,16.64,3.11z"
      />
    </IconSvg>
  );
};

export default memo(Heart);
